// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/printReceipt/stylesheet/style.scss
 ** module id = 427
 ** module chunks = 1
 **/